"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dispatchCartUpdated;
var _customEventNames = require("@nike/custom-event-names");
var _createCustomEvent = _interopRequireDefault(require("../../../../../utils/create-custom-event"));
var _dispatchCustomEvent = _interopRequireDefault(require("../../../../../utils/dispatch-custom-event"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Dispatches the cartUpdated custom event to notify external applications
 * that cart items have been modified and they should re-fetch their cart data.
 *
 * This event fires when:
 * - Items are added to the cart
 * - Items are removed from the cart
 * - Item quantity is changed
 * - Item size is changed
 * - Value added services are modified
 * - Promo codes are added or removed
 * - Cart is fetched
 * - User's cart is merged
 *
 * External applications listening to this event do not receive specific cart data,
 * just a notification that the cart has been modified. This allows them to
 * independently query the carts service for the latest data.
 */
function dispatchCartUpdated() {
  var cartUpdatedEvent = (0, _createCustomEvent["default"])(_customEventNames.CART_UPDATED_EVENT_NAME, {
    bubbles: true,
    detail: {
      message: 'Cart items have been modified'
    }
  });
  (0, _dispatchCustomEvent["default"])(cartUpdatedEvent);
}